export var UserMembershipState;
(function (UserMembershipState) {
  UserMembershipState["PENDING"] = "PENDING";
  UserMembershipState["ACCEPTED"] = "ACCEPTED";
  UserMembershipState["EXPIRED"] = "EXPIRED";
  UserMembershipState["INHERITED"] = "INHERITED";
})(UserMembershipState || (UserMembershipState = {}));
